/**
 * RTDB Cache System for Football Dashboard
 * Main export file for all RTDB functionality
 */

import { RTDB_FEATURES } from './rtdbConfig';
import cacheWarmer from './utils/cacheWarmer';

// Core exports
export { default as rtdbFootballService } from './rtdbFootballService';
export { default as rtdbCache } from './rtdbCache';
export { RTDB_FEATURES, TTL_CONFIG } from './rtdbConfig';

// Hooks
export {
  useRTDBFixtures,
  useRTDBLiveFixtures,
  useRTDBOdds,
  useRTDBLiveOdds,
  useRTDBStandings,
  useRTDBTopScorers
} from './hooks';

// Utilities
export { default as cacheWarmer } from './utils/cacheWarmer';
export { default as cacheAnalytics } from './utils/cacheAnalytics';

// Auto-start cache warming in production
if (RTDB_FEATURES.USE_RTDB_CACHE && process.env.NODE_ENV === 'production') {
  // Start warming popular data every 5 minutes
  setTimeout(() => {
    cacheWarmer.startAutoWarming(5);
  }, 5000); // Delay startup by 5 seconds
}

// Development helpers
if (process.env.NODE_ENV === 'development') {
  console.log('🚀 RTDB Cache System Initialized');
  console.log('Available commands:');
  console.log('  RTDBCache.info() - Cache information');
  console.log('  RTDBCache.stats() - Cache statistics');
  console.log('  RTDBCache.clear() - Clear cache');
  console.log('  RTDBFootball.warmCache() - Warm cache');
  console.log('  RTDBAnalytics.report() - Generate analytics report');
  console.log('  RTDBCacheWarmer.status() - Warming status');
}